import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import { reducer as publicationReducer } from './ducks/Publications';
import App from './App';
import * as serviceWorker from './serviceWorker';

const store = createStore(publicationReducer);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
